(() => {
  if (customElements.get('campaign-footer')) return;

  customElements.define('campaign-footer', class extends HTMLElement {
    connectedCallback() {
      const setVisible = (visible) => {
        document.documentElement.classList.toggle('campaign-footer-in-view', visible);
      };
      const checkPosition = () => {
        const rect = this.getBoundingClientRect();
        setVisible(rect.top < window.innerHeight && rect.bottom > 0);
      };
      checkPosition();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          setVisible(entries.some((entry) => entry.isIntersecting));
        });
        this.observer.observe(this);
      } else {
        this.checkPosition = checkPosition;
        window.addEventListener('scroll', checkPosition, { passive: true });
        window.addEventListener('resize', checkPosition);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.checkPosition) {
        window.removeEventListener('scroll', this.checkPosition);
        window.removeEventListener('resize', this.checkPosition);
      }
      document.documentElement.classList.remove('campaign-footer-in-view');
    }
  });
})();
